export default {
  auth: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/default.vue").then(m => m.default || m),
  home: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/home.vue").then(m => m.default || m)
}